import { useMutation, useQuery } from "@tanstack/react-query";
import {
  OrganizationLabelService,
  OrganizationLabelsFindAllPayload,
} from "../services/organizationLabels.service";
import { OrganizationLabelPayload } from "../domain/organizationLabels.interface";

export const useOrganizationLabels = (
  filters: OrganizationLabelsFindAllPayload
) => {
  const {
    data: organizationLabels,
    isLoading: isLoadingOrganizationLabels,
    isFetching: isFetchingOrganizationLabels,
    refetch: refetchOrganizationLabels,
  } = useQuery({
    queryKey: ["parca-organization-labels-list"],
    queryFn: () => OrganizationLabelService.findAll(filters),
  });

  return {
    organizationLabels,
    isLoadingOrganizationLabels,
    isFetchingOrganizationLabels,
    refetchOrganizationLabels,
  };
};

export const useActiveOrganizationLabels = (enabled = true) => {
  const {
    data: activeOrganizationLabels,
    isLoading: isLoadingActiveOrganizationLabels,
    refetch: refetchActiveOrganizationLabels,
  } = useQuery({
    queryKey: ["parca-organization-labels-active"],
    queryFn: () => OrganizationLabelService.findActive(),
    enabled,
  });

  return {
    activeOrganizationLabels,
    isLoadingActiveOrganizationLabels,
    refetchActiveOrganizationLabels,
  };
};

export const useCreateOrganizationLabel = () => {
  return useMutation({
    mutationFn: (payload: OrganizationLabelPayload) =>
      OrganizationLabelService.createOne(payload),
  });
};

export const useUpdateOrganizationLabel = () => {
  return useMutation({
    mutationFn: ({
      id,
      payload,
    }: {
      id: string;
      payload: OrganizationLabelPayload;
    }) => OrganizationLabelService.updateOne({ id, payload }),
  });
};

export const useArchiveOrganizationLabel = () => {
  return useMutation({
    mutationFn: (id: string) => OrganizationLabelService.archiveOne(id),
  });
};
